export enum ACTOR_TYPE {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  ALL_USERS = 'ALL_USER',
}
